module.exports = __webpack_public_path__ + "static/img/Salesforce-logo.6e50c62.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Salesforce-logo.svg
// module id = oqy2
// module chunks = 134